import { render } from "./ArgumentListAll.vue?vue&type=template&id=3875192a&scoped=true"
import script from "./ArgumentListAll.vue?vue&type=script&lang=js"
export * from "./ArgumentListAll.vue?vue&type=script&lang=js"

import "./ArgumentListAll.vue?vue&type=style&index=0&id=3875192a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3875192a"]])

export default __exports__